import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface UseFetchCartItemsParams {
  limit?: number;
  enabled?: boolean;
  is_product?: boolean;
}

export const useFetchCartItems = (params: UseFetchCartItemsParams = {}) => {
  const { limit = 10, enabled = true, is_product = true } = params;

  const queryFn = async ({ pageParam = 1 }) => {
    const response = await fetchClient.GET("/cart", {
      params: {
        query: {
          page: typeof pageParam === "number" ? pageParam : 1,
          limit,
          is_product,
        },
      },
    });

    const error = response.error;
    if (error) throw error;
    return response.data;
  };

  const {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["cart", "items", limit, is_product],
    queryFn,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination;
      if (pagination?.hasNextPage) return pagination.page + 1;
      return undefined;
    },
    enabled,
  });

  return {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
    refetch,
  };
};
